<template>
    <div v-loading="loading" element-loading-text="保存中...">
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>代理下单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-form :model="servcOrder" :rules="checkRetails" ref="ruleForm" class="demo-ruleForm">
            <div class="block-container">
                <div class="content-caption dashed">
                    <span>选择合同</span>
                </div>
                <div class="simple-form">
                    <div class="form-group center">
                        <div class="form-label">
                            <label>选择合同</label>
                        </div>
                        <div class="form-value">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="servcOrder.contractName"></el-input>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label>合同编号</label>
                        </div>
                        <div class="form-value">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="servcOrder.contractOriginalNo"></el-input>
                        </div>
                    </div>
                    <div class="form-group center" v-if="servcOrder.contractId != null && trackPhaseList != null && trackPhaseList.length > 0">
                        <div class="form-label">
                            <label>选择合同阶段</label>
                        </div>
                        <div class="form-value">
                            <el-select placeholder="请选择" class="fl" v-model="trackPhaseId">
                                <el-option v-for="trackPhase in trackPhaseList" :key="trackPhase.id" :label="trackPhase.name" :value="trackPhase.id"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>

                <div class="content-caption dashed">
                    <span>添加服务</span>
                </div>
                <table class="custom-tbl">
                    <thead class="head">
                    <tr class="row">
                        <th width="50">
                            <el-checkbox v-model="allChecked" @change="selectAll();"></el-checkbox>
                        </th>
                        <th width="" style="text-align: left">名称</th>
                        <th width="80" style="text-align: right">质保期(天)</th>
                        <th width="80" style="text-align: right">上门费(元)</th>
                        <th width="80" style="text-align: right">服务费(元)</th>
                        <th width="" style="text-align: left">固定规格说明</th>
                        <th width="110" style="text-align: right">响应时长(分钟)</th>
                        <th width="110" style="text-align: right">到达时长(分钟)</th>
                        <th width="110" style="text-align: right">完成时长(分钟)</th>
                        <th width="80" style="text-align: right">服务次数</th>
                        <th width="80" style="text-align: right">已服务次数</th>
                        <!--<th width="150" style="text-align: left">服务商品分类</th>-->
                        <th width="60" style="text-align: left">操作</th>
                    </tr>
                    </thead>
                    <tbody class="body">
                    <tr class="row" v-for="servOrderItem in servcOrder.servOrderItemList">
                        <td>
                            <el-checkbox v-model="servOrderItem.checked" @change="selectMku(servOrderItem);"></el-checkbox>
                        </td>
                        <td style="text-align: left">{{servOrderItem.name}}</td>
                        <td style="text-align: right">{{servOrderItem.wrntPeriod}}</td>
                        <td style="text-align: right">{{parseFloat(servOrderItem.toDoorFee || 0).toFixed(2)}}</td>
                        <td style="text-align: right">{{parseFloat(servOrderItem.generallFee || 0).toFixed(2)}}</td>
                        <td style="text-align: left">{{servOrderItem.msu.fixedSpec}}</td>
                        <td style="text-align: right">{{servOrderItem.yqRspTimeMi}}</td>
                        <td style="text-align: right">{{servOrderItem.yqArriveTimeMi}}</td>
                        <td style="text-align: right">{{servOrderItem.yqRepairedTimeMi}}</td>
                        <td style="text-align: right">{{servOrderItem.quantity || 0}}</td>
                        <td style="text-align: right">{{servOrderItem.usedQuantity}}</td>
                        <!--<td style="text-align: left">-->
                        <!--<p v-if="servOrderItem.goodsCatId != null">{{servOrderItem.goodsCatName}}</p>-->
                        <!--<div>-->
                        <!--<span class="swb-btn-link" @click="selectServcGoodsCat(servOrderItem.servcId, servOrderItem.ssuId)">选择商品分类</span>-->
                        <!--</div>-->
                        <!--</td>-->
                        <td style="text-align: left"><a class="swb-btn-link" @click="removeMsu(servOrderItem.ssuId)">移除</a></td>
                    </tr>
                    <tr class="row">
                        <td colspan="8" class="display-none">
                            <div class="no-data">
                                <i class="icon iconfont icon-zanwushuju mr10" style="font-size: 58px;vertical-align: middle;"></i>
                                <span class="">暂无数据 . . .</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="content-caption dashed">
                    <span>选择服务商</span>
                </div>
                <div class="simple-form">

                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">服务商名称</label>
                        </div>
                        <div class="form-value">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="servcOrder.sellerName"></el-input>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label></label>
                        </div>
                        <div class="form-value">

                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">选择零售商</label>
                        </div>
                        <div class="form-value">
                            <el-form-item prop="peerMerchantName">
                                <el-input class="width-1-5x bottom-line" :disabled="true" v-model="servcOrder.buyerName"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">零售商机构</label>
                        </div>
                        <div class="form-value">
                            <el-form-item prop="buyerShopName">
                                <el-input class="width-1-5x bottom-line" :disabled="true" v-model="servcOrder.buyerShopName"></el-input>
                                <i v-if="isClick" class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectRetailOrg"></i>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">机构联系人</label>
                        </div>
                        <div class="form-value">
                            <el-input class="width-1-5x" v-model="servcOrder.buyerShopContactName"></el-input>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">机构电话</label>
                        </div>
                        <div class="form-value">
                            <el-input class="width-1-5x " v-model="servcOrder.buyerShopContactTel"></el-input>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">预约时间</label>
                        </div>
                        <div class="form-value">
                            <el-date-picker class="width-1-5x" v-model="planTime" type="datetime" placeholder="选择日期" format="yyyy-MM-dd HH:mm"></el-date-picker>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">交易总金额</label>
                        </div>
                        <div class="form-value">
                            <el-input class="width-1-5x bottom-line" disabled v-model="servcOrder.totalAmount"></el-input>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="">故障描述</label>
                        </div>
                        <div class="form-value">
                            <el-input type="textarea" class="width-1-5x bottom-line" :rows="3" placeholder="故障描述最大长度120个字" :maxlength="120" :minlength="10" v-model="servcOrder.troubleDesc"></el-input>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="">附言</label>
                        </div>
                        <div class="form-value">
                            <el-input type="textarea" class="width-1-5x bottom-line" :rows="3" placeholder="附言最大长度120个字" :maxlength="120" :minlength="10" v-model="servcOrder.postscript"></el-input>
                        </div>
                    </div>
                </div>
            </div>

        </el-form>
        <div class="form-toolbar">
            <button class="swb-btn" @click="submitServcOrder">提交</button>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import{ selectRedioServcGoodsCatRel } from '../servc/selectDlg';

    import contractApi from '../../api/contract'
    import merchtFinacApi from '../../api/merchtFinac'
    import merchtQualiApi from '../../api/merchtQuali'
    import servcOrderApi from '../../api/servcOrder'

    import SwbContractServcOrderList from './ContractServcOrderList.vue'
    Routes.add(SwbContractServcOrderList);
    import SwbOrgTree from '../orgStruct/OrgTree';
    Vue.regist(SwbOrgTree);

    export default {
        name: 'swb-servc-order-create',
        path: '/servc/order/create',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: false,
        authen: false,
        desc: '服务代理下单',
        data: function () {
            let checkRetailShop = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('零售商机构不能为空'));
                } else {
                    callback();
                }
            };
            return {
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                servcOrder: {
                    servOrderItemList: [],
                    contractId: null,
                    contractName: null,
                    contractOriginalNo: null,
                    contractNo: null,
                    peerMerchantName: null,
                    buyerShopId: null,
                    buyerShopName: null,
                    buyerShopContactTel: null,
                    buyerShopContactName: null,
                    buyerType: null,
                    buyerName: null,
                    buyerId: null,
                    payTiming: null,
                    payWay: null,
                    recvFrame: 0,
                    invoiceType: null,
                    invoiceSubjectType: 1,
                    invoiceTitle: null,
                    invoiceContentTag: null,
                    taxPayerNo: null,
                    totalAmount: 0,
                    sellerId: null,
                    sellerName: null,
                    sellerType: null,
                    contractType: null,
                },
                trackPhaseId: null,
                trackPhaseList: [],
                //发票信息
                invoiceClaimed: false,
                //
                planTime: new Date(),
                //
                payWayList: [],
                payTimingList: [],
                recvFrameList: [],
                invoiceTypeList: [],
                invoiceSubjectTypeList: [],
                invoiceContentTagList: [],
                //
                plain: null,
                //
                allChecked: false,
                isShow: false,

                ///
                contract: {},
                msuList: [],
                retail: {},
                contractId: null,
                shopRetail: {},
                data: {},

                //
                loading: false,
                checkRetails: {
                    buyerShopName: [{
                        validator: checkRetailShop,
                        trigger: 'change'
                    }],
                },

                isClick: true
            }
        },
        created: function () {
            let self = this;
            self.servcOrder.contractId = this.$route.query.contractId || null;
            self.recvFrameList = getEnumList('recvFrame');
            self.invoiceSubjectTypeList = getEnumList('invoiceSubjectType');
            if(!Utils.isNoB(self.servcOrder.contractId)) {
                self.getContractServcPageList();
                self.getContractTrackPhase(self.servcOrder.contractId);
            } else {
                self.servcOrder.buyerShopId = this.$route.query.retailerShopId || null;
                if(!Utils.isNoB(self.servcOrder.buyerShopId)) {
                    self.getShopContractServcPageList();
                }
            }
        },
        methods: {
            // 获取合同阶段
            getContractTrackPhase: function (contractId) {
                let self = this;
                self.trackPhaseId = null;
                let params = {};
                params.contractId = contractId;
                contractApi.getContractTrackPhaseListByContractId(params, function (reault) {
                    if(reault.type == 'info') {
                        self.trackPhaseList = reault.data;
                        let trackPhaseList = self.trackPhaseList;
                        if(!Utils.isNoB(trackPhaseList) && trackPhaseList.length > 0) {
                            for(let i = 0; i < trackPhaseList.length; i++) {
                                let trackPhase = trackPhaseList[i];
                                if(trackPhase.active) {
                                    self.trackPhaseId = trackPhase.id;
                                }
                            }
                        }
                    } else {
                        MsgBox.warning(reault.message);
                    }
                })
            },
            getContractServcPageList: function () {
                let self = this;
                let postData = {};
                let servcOrder = self.servcOrder;
                postData.id = servcOrder.contractId;
                let lastMsgBoxDlg = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        let data = result.data;
                        if(data.curValid) {
                            servcOrder.curValid = data.curValid;
                            servcOrder.contractName = data.title;
                            servcOrder.contractOriginalNo = data.originalNo;
                            servcOrder.contractNo = data.no;
                            servcOrder.sellerId = data.sndPartyId;
                            servcOrder.sellerType = data.sndPartyType;
                            servcOrder.sellerName = data.sndPartyName;
                            servcOrder.buyerId = data.fstPartyId;
                            servcOrder.buyerName = data.fstPartyName;
                            servcOrder.buyerType = data.fstPartyType;
                            servcOrder.payWay = data.payWay;
                            servcOrder.invoiceType = data.invoiceType;
                            servcOrder.invoiceTitle = data.invoiceTitle;
                            servcOrder.invoiceContentTag = data.invoiceContentTag;
                            servcOrder.curValid = data.curValid;
                            servcOrder.taxPayerNo = data.taxPayerNo;
                            let servOrderItemList = [];
                            let contractServcList = data.contractServcList || [];
                            for(let i = 0; i < contractServcList.length; i++) {
                                let contractServc = contractServcList[i];
                                contractServc.contractItemId = contractServc.id;
                                contractServc.checked = false;
                                contractServc.goodsCatId = null;
                                contractServc.goodsCatName = null;
                                contractServc.generallFee = contractServc.price;
                                contractServc.yqRspTimeMi = contractServc.rspTimeMi;
                                contractServc.yqArriveTimeMi = contractServc.arriveTimeMi;
                                contractServc.yqRepairedTimeMi = contractServc.repairedTimeMi;
                                servOrderItemList.push(contractServc);
                            }
//                            let contractServc2List = data.contractServc2List || [];
//                            for(let i = 0; i < contractServc2List.length; i++) {
//                                let contractServc = contractServc2List[i];
//                                contractServc.contractItemId = contractServc.id;
//                                contractServc.checked = false;
//                                contractServc.goodsCatId = null;
//                                contractServc.goodsCatName = null;
//                                contractServc.generallFee = contractServc.price;
//                                contractServc.yqRspTimeMi = contractServc.rspTimeMi;
//                                contractServc.yqArriveTimeMi = contractServc.arriveTimeMi;
//                                contractServc.yqRepairedTimeMi = contractServc.repairedTimeMi;
//                                servOrderItemList.push(contractServc);
//                            }
                            servcOrder.contractType = getEnumInfoWith("contractType", "value", data.typeId);
                            // self.selectInvoiceType(data.sndPartyId, data.sndPartyType);
                            // self.selectPayTiming(data.sndPartyId, data.sndPartyType);
                            // self.selectPayWay(data.sndPartyId, data.sndPartyType);
                            // self.selectInvoiceCtntTag(data.sndPartyId, data.sndPartyType);
                            servcOrder.servOrderItemList = Utils.merge([], servOrderItemList);
                            self.servcOrder = Utils.merge({}, servcOrder);
                        } else {
                            MsgBox.warning("请选择有效的合同");
                            return false;
                        }

                    } else {
                        MsgBox.warning(result.message);
                        return false;
                    }
                });
            },
            selectAll: function () {
                let self = this;
                let servcOrder = self.servcOrder;
                let servOrderItemList = servcOrder.servOrderItemList || [];
                if(self.allChecked) {
                    if(servOrderItemList != null && servOrderItemList.length > 0) {
                        let amount = 0;
                        for(let i = 0; i < servOrderItemList.length > 0; i++) {
                            let servOrderItem = servOrderItemList[i];
                            servOrderItem.checked = true;
                            if(!Utils.isNoB(self.servcOrder.contractId)) {
                                amount = (parseFloat(amount) + parseFloat(servOrderItem.price || 0) + parseFloat(servOrderItem.toDoorFee || 0));
                            } else {
                                amount = (parseFloat(amount) + parseFloat(servOrderItem.toDoorFee || 0));
                            }
                        }
                        self.servcOrder.totalAmount = amount.toFixed(2);
                    }
                    self.allChecked = true;
                } else {
                    if(servOrderItemList != null && servOrderItemList.length > 0) {
                        for(let i = 0; i < servOrderItemList.length > 0; i++) {
                            let servOrderItem = servOrderItemList[i];
                            servOrderItem.checked = false;
                            self.servcOrder.totalAmount = 0;
                        }
                    }
                    self.allChecked = false;
                }

                self.servcOrder.servOrderItemList = Utils.merge([], servOrderItemList);
            },
            selectMku: function (servOrderItem) {
                let self = this;
                self.isAllSelect();
                if(servOrderItem.checked) {
                    if(!Utils.isNoB(self.servcOrder.contractId)) {
                        self.servcOrder.totalAmount = (parseFloat(self.servcOrder.totalAmount || 0) + parseFloat(servOrderItem.price || 0) + parseFloat(servOrderItem.toDoorFee || 0)).toFixed(2);
                    } else {
                        self.servcOrder.totalAmount = (parseFloat(self.servcOrder.totalAmount || 0) + parseFloat(servOrderItem.toDoorFee || 0)).toFixed(2);
                    }
                } else {
                    if(!Utils.isNoB(self.servcOrder.contractId)) {
                        self.servcOrder.totalAmount = (parseFloat(self.servcOrder.totalAmount || 0) - parseFloat(servOrderItem.price || 0) - parseFloat(servOrderItem.toDoorFee || 0)).toFixed(2);
                    } else {
                        self.servcOrder.totalAmount = (parseFloat(self.servcOrder.totalAmount || 0) - parseFloat(servOrderItem.toDoorFee || 0)).toFixed(2);
                    }
                    if(self.servcOrder.totalAmount < 0) {
                        self.servcOrder.totalAmount = 0;
                    }
                }
            },
            isAllSelect: function () {
                let self = this;
                let servOrderItemList = self.servcOrder.servOrderItemList;
                for(let i = 0; i < servOrderItemList.length; i++) {
                    if(servOrderItemList[i].checked == false) {
                        self.allChecked = false;
                        return false;
                    }
                }
                self.allChecked = true;
                return true;
            },
            removeMsu: function (ssuId) {
                let self = this;
                let servOrderItemList = self.servcOrder.servOrderItemList || [];
                for(let i = 0; i < servOrderItemList.length; i++) {
                    let servOrderItem = servOrderItemList[i];
                    if(servOrderItem.ssuId == ssuId) {
                        self.servcOrder.servOrderItemList.splice(i, 1);
                    }
                }
            },
            selectServcGoodsCat: function (servcId, ssuId) {
                let self = this;
                let servcOrderItemList = self.servcOrder.servOrderItemList || [];
                let filter = {};
                filter.merchantId = self.servcOrder.sellerId;
                filter.merchantType = self.servcOrder.sellerType;
                filter.servcId = servcId;
                selectRedioServcGoodsCatRel(filter, function (result) {
                    let servcGoodsCatRel = result;
                    for(let i = 0; i < servcOrderItemList.length; i++) {
                        let servOrderItem = servcOrderItemList[i];
                        if(servOrderItem.ssuId == ssuId) {
                            servOrderItem.goodsCatId = servcGoodsCatRel.goodsCatId;
                            servOrderItem.goodsCatName = servcGoodsCatRel.goodsCatName;
                        }
                    }
                    self.servcOrder.servcOrderItemList = Utils.merge([], servcOrderItemList);
                });

            },
            // 零售商门店标识功能弱化，选择门店改成选择机构
            selectRetailOrg(){
                let servcOrder = this.servcOrder;
                if(Utils.isNoB(servcOrder.buyerId)) {
                    MsgBox.warning("请选择零售商");
                    return;
                }
                Vue.$showDialog({
                    title: '零售商机构-选择',
                    width: 900,
                    height: 700,
                    showCloseBtn: true,
                    template: '<div class = "">' +
                    '<swb-org-tree :isSelectThisLevel="isSelectThisLevel" :isRadio="isRadio" :isCom="isCom"  ref="swb_org_tree"></swb-org-tree>' +
                    '</div>',
                    data: {
                        isRadio: true,
                        isCom: true,
                        isSelectThisLevel: true
                    },
                    okClicked: function () {
                        let self = this;
                        let result = self.$refs.swb_org_tree.getDlgResult() || {};
                        console.log(result);
                        if(result.type == "info") {
                            //
                            let shopRetail = result.data;
                            servcOrder.buyerShopId = shopRetail.id;
                            servcOrder.buyerShopName = shopRetail.name;
                            servcOrder.buyerShopContactTel = shopRetail.contactTel;
                            servcOrder.buyerShopContactName = shopRetail.contactName;
                            //
                        } else {
                            return false;
                        }
                    },
                    lifecycle: {
                        created: function () {
                        }
                    },
                });
            },
            //商户（支持的）发票类型
            selectInvoiceType: function (sellerId, sellerType) {
                let self = this;
                let postData = {};
                postData.merchantId = sellerId;
                postData.merchantType = sellerType;
                let lastMsgBoxDlg = MsgBox.loading();
                merchtFinacApi.getMerchantInvoiceTypeListAvailable(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        let invoiceTypeList = result.data;
                        for(let i = 0; i < invoiceTypeList.length; i++) {
                            let invoiceType = invoiceTypeList[i];
                            if(invoiceType.defaulted) {
                                self.servcOrder.invoiceType = invoiceType.value;
                            }
                        }
                        self.invoiceTypeList = Utils.merge([], invoiceTypeList);
                        self.servcOrder = Utils.merge({}, self.servcOrder);
                    }
                })
            },
            //商户（支持的）付款时机
            selectPayTiming: function (sellerId, sellerType) {
                let self = this;
                let postData = {};
                postData.merchantId = sellerId;
                postData.merchantType = sellerType;
                let lastMsgBoxDlg = MsgBox.loading();
                merchtFinacApi.getMerchantPayTimingList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        let payTimingList = result.data;
                        for(let i = 0; i < payTimingList.length; i++) {
                            let payTiming = payTimingList[i];
                            if(payTiming.defaulted) {
                                self.servcOrder.payTiming = payTiming.value;
                            }
                        }
                        self.payTimingList = Utils.merge([], payTimingList);
                        self.servcOrder = Utils.merge({}, self.servcOrder);
                    }
                })
            },
            //商户（支持的）付款方式
            selectPayWay: function (sellerId, sellerType) {
                let self = this;
                let postData = {};
                postData.merchantId = sellerId;
                postData.merchantType = sellerType;
                let lastMsgBoxDlg = MsgBox.loading();
                merchtFinacApi.getMerchantPayWayList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        let payWayList = result.data;
                        for(let i = 0; i < payWayList.length; i++) {
                            let payWay = payWayList[i];
                            if(payWay.defaulted) {
                                self.servcOrder.payWay = payWay.value;
                            }
                        }
                        self.payWayList = Utils.merge([], payWayList);
                        self.servcOrder = Utils.merge({}, self.servcOrder);
                    }
                })
            },
            //商户（支持的）发票内容标签
            selectInvoiceCtntTag: function (sellerId, sellerType) {
                let self = this;
                let postData = {};
                postData.merchantId = sellerId;
                postData.merchantType = sellerType;
                let lastMsgBoxDlg = MsgBox.loading();
                merchtFinacApi.getMerchantInvoiceCtntTagList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        let invoiceContentTagList = result.data;
                        for(let i = 0; i < invoiceContentTagList.length; i++) {
                            let invoiceContentTag = invoiceContentTagList[i];
                            if(invoiceContentTag.defaulted) {
                                self.servcOrder.invoiceContentTag = invoiceContentTag.name;
                            }
                        }
                        self.invoiceContentTagList = Utils.merge([], invoiceContentTagList);
                    }
                    self.servcOrder = Utils.merge({}, self.servcOrder);
                })
            },

            //选择发票方式
            //选择支付方式
            changPayWay: function (item, index) {
                let self = this;
                for(let i = 0; i < self.payWayList.length; i++) {
                    if(i == index) {
                        self.servcOrder.payWay = item.value;
                    }
                }
                self.servcOrder = Utils.merge({}, self.servcOrder);
            },
            //选择发票的主体类型
            changPayTiming: function (item, index) {
                let self = this;
                for(let i = 0; i < self.payTimingList.length; i++) {
                    if(i == index) {
                        self.servcOrder.payTiming = item.value;
                    }
                }
                self.servcOrder = Utils.merge({}, self.servcOrder);
            },
            //选择收货时段
            changRecvFrame: function (item, index) {
                let self = this;
                for(let i = 0; i < self.recvFrameList.length; i++) {
                    if(i == index) {
                        self.servcOrder.recvFrame = item.value;
                    }
                }
                self.servcOrder = Utils.merge({}, self.servcOrder);
            },
            //选择主体类型
            changInvoiceSubjectType: function (item, index) {
                let self = this;
                for(let i = 0; i < self.invoiceSubjectTypeList.length; i++) {
                    if(i == index) {
                        self.servcOrder.invoiceSubjectType = item.value;
                    }
                }
                self.servcOrder = Utils.merge({}, self.servcOrder);
            },
            //选择内容标签
            changInvoiceContentTag: function (item, index) {
                let self = this;
                for(let i = 0; i < self.invoiceContentTagList.length; i++) {
                    if(i == index) {
                        self.servcOrder.invoiceContentTag = item.name;
                    }
                }
                self.servcOrder = Utils.merge({}, self.servcOrder);
            },
            submitServcOrder: function () {
                let self = this;
                let servcOrder = self.servcOrder;
                //
                let trackPhaseList = self.trackPhaseList;
                if(!Utils.isNoB(self.servcOrder.contractId) && trackPhaseList != null && trackPhaseList.length > 0 && Utils.isNoB(self.trackPhaseId)) {
                    MsgBox.warning("请选择合同阶段");
                    return;
                }
                if(!Utils.isNoB(self.servcOrder.contractId) && trackPhaseList != null && trackPhaseList.length > 0) {
                    servcOrder.trackPhaseId = self.trackPhaseId;
                    for(let i = 0; i < trackPhaseList.length; i++) {
                        let trackPhase = trackPhaseList[i];
                        if(self.trackPhaseId == trackPhase.id) {
                            servcOrder.trackPhaseName = trackPhase.name;
                        }
                    }
                }
                servcOrder.invoiceClaimed = self.invoiceClaimed;
                servcOrder.payMode = self.servcOrder.payTiming;
                servcOrder.planTime = self.planTime.format("yyyy-MM-dd HH:mm");
                if(Utils.isNoB(servcOrder.buyerShopContactName)) {
                    MsgBox.warning("请添加联系人");
                    return false;
                }
                if(Utils.isNoB(servcOrder.buyerShopContactTel)) {
                    MsgBox.warning("请添加联系电话");
                    return false;
                } else {
                    if(!Utils.isPhoneNo(servcOrder.buyerShopContactTel)) {
                        MsgBox.warning("请添加正确联系电话");
                        return false;
                    }
                }
                servcOrder.submitted = true;
                let servOrderItemList = [];
                if(self.servcOrder.servOrderItemList.length <= 0) {
                    MsgBox.warning("请添加服务");
                    return false;
                }
                for(let i = 0; i < self.servcOrder.servOrderItemList.length; i++) {
                    let servOrderItem = self.servcOrder.servOrderItemList[i];
                    if(servOrderItem.checked) {
                        servOrderItem.trackPhaseId = servcOrder.trackPhaseId;
                        servOrderItem.trackPhaseName = servcOrder.trackPhaseName;
                        servOrderItemList.push(servOrderItem);
                    }
                }
                if(servOrderItemList.length <= 0) {
                    MsgBox.warning("请选择对应的服务");
                    return false;
                }
                for(let i = 0; i < servOrderItemList.length; i++) {
                    let servOrderItem = servOrderItemList[i];
                    // 判断 服务次数
                    let quantity = servOrderItem.quantity;
                    let usedQuantity = servOrderItem.usedQuantity;
                    if(usedQuantity >= quantity) {
                        MsgBox.warning("【" + servOrderItem.name + "】服务次数已经用尽！");
                        return;
                    }
                    //
//                    if(Utils.isNoB(servOrderItem.goodsCatId)) {
//                        MsgBox.warning("服务【" + servOrderItem.name + "】没有对应的商品分类信息");
//                        return false;
//                    }
                }
                servcOrder.servcOrderItemList = servOrderItemList;

                let tradePostData = {};
                tradePostData.merchantId = self.servcOrder.buyerId;
                tradePostData.merchantType = self.servcOrder.buyerType;
                //
                let postData = servcOrder;
                let lastMsgBoxDlg = MsgBox.loading();
                servcOrderApi.saveServcOrderForContract(postData, function (result) {
                    if(result.type == 'info') {
                        setTimeout(function () {
                            self.searchOrder();
                            lastMsgBoxDlg.close();
                            MsgBox.success("保存成功");
                        }, 5000);
                    } else {
                        lastMsgBoxDlg.close();
                        MsgBox.warning(result.message);
                        return false;
                    }
                })
            },
            searchOrder: function () {
                let self = this;
                let contractId = self.servcOrder.contractId;
                this.$router.push({
                    path: SwbContractServcOrderList.path,
                    query: {
                        contractId: contractId,
                    }
                });

            }
            ,
            /*rollBackContract: function () {
             this.$router.push({
             path: '/servc/purch/contract/page/list',
             });
             },
             rollBackIntegPurchContract: function () {
             this.$router.push({
             path: '/integ/purch/contract/page/list',
             });
             },*/
            getShopContractServcPageList: function () {
                let self = this;
                let postData = {};
                let servcOrder = self.servcOrder;
                postData.retailerShopId = self.$route.query.retailerShopId;
                postData.contractOriginalNo = self.$route.query.contractOriginalNo;
                postData.ssuId = self.$route.query.ssuId;
                let lastMsgBoxDlg = MsgBox.loading();
                contractApi.getContractAvlServcOfRetailerShopByUk(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        let data = result.data;
                        if(data.contract != null) {
                            servcOrder.contractId = data.contract.id;
                            servcOrder.contractName = data.contract.title;
                            servcOrder.contractOriginalNo = data.contractOriginalNo;
                            servcOrder.contractNo = data.contract.no;
                            servcOrder.sellerId = data.contract.sndPartyId;
                            servcOrder.sellerType = data.contract.sndPartyType;
                            servcOrder.sellerName = data.contract.sndPartyName;
                            servcOrder.buyerId = data.contract.fstPartyId;
                            servcOrder.buyerName = data.contract.fstPartyName;
                            servcOrder.buyerType = data.contract.fstPartyType;
                            servcOrder.payWay = data.contract.payWay;
                            servcOrder.invoiceType = data.contract.invoiceType;
                            servcOrder.invoiceTitle = data.contract.invoiceTitle;
                            servcOrder.invoiceContentTag = data.contract.invoiceContentTag;
                            servcOrder.curValid = data.contract.curValid;
                            servcOrder.taxPayerNo = data.contract.taxPayerNo;
                            servcOrder.buyerShopFlag = true;
                            servcOrder.buyerShopId = data.retailerShopId;
                            servcOrder.buyerShopLevel = data.retailerShopLevel;
                            servcOrder.buyerShopName = data.retailerComName;
                            servcOrder.buyerShopContactName = data.contactName;
                            servcOrder.buyerShopContactTel = data.contactTel;
                            let servOrderItemList = [];
                            let contractServc = {};
                            contractServc.checked = true;
                            contractServc.ssuId = data.ssuId;
                            contractServc.name = data.servcName;
                            contractServc.wrntPeriod = data.wrntPeriod;
                            contractServc.price = data.price;
                            contractServc.msu = data.msu;
                            servOrderItemList.push(contractServc);
                            servcOrder.contractType = getEnumInfoWith("contractType", "value", data.contract.typeId);
                            servcOrder.servOrderItemList = servOrderItemList;
                            self.servcOrder = Utils.merge({}, servcOrder);

                            self.isClick = false;
                        } else {
                            MsgBox.warning("请选择有效的合同");
                            return false;
                        }

                    } else {
                        MsgBox.warning(result.message);
                        return false;
                    }
                });
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/compo/servcOrder/ServcOrderCreate.vue